/**
 * @generated SignedSource<<ba57e8e490ff3830fbec647648f4f846>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountBaseInlineFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly name: string;
  readonly platformAccess: any | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "accountBaseInlineFragment";
};
export type accountBaseInlineFragment$key = {
  readonly " $data"?: accountBaseInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "accountBaseInlineFragment"
};

(node as any).hash = "5bb1857ada68c7b57c8c55e15d1dc650";

export default node;
